import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import Table from './Table'
import { Link } from 'react-router-dom'
import { FirebaseApp } from 'firebase/app'
import { getDatabase, onValue, ref, set, update } from 'firebase/database'
import { app } from '../firebaseConfig'
import Cookies from 'js-cookie'
const Leaderboard = () => {
    const [data, setData] = useState(null);
    const db = getDatabase(app);
    const [loading, setLoading] = useState(true);
    const [maneuverArray , setManeuverArray] = useState([]);
    const [leaderBoardArray , setLeaderboardArray] = useState([]);

    useEffect(() => {
        const fetchData = () => {
            const dbRef = ref(db, 'globalranking');
            onValue(dbRef, (snapshot) => {
                const dataSet = snapshot.val();
                setData(dataSet);
                setLoading(false);
                // console.log("printing data from database ", dataSet);
            });
        };

        fetchData();
    }, [db]);

    
    useEffect(() => {
        let tempManeuverArray = [];
        let tempLeaderboardArray = [];
        if (!loading) {
            Object.entries(data).forEach(([key, value]) => {
                tempManeuverArray.push(key);
                tempLeaderboardArray.push(value);
            })
            tempLeaderboardArray.forEach(item => {
                item.rankings.sort((a, b) => b.bestScore - a.bestScore);
                let obj;
                item.rankings.forEach((rankItem , index) => {
                    rankItem.rank = index+1
                    // console.log("Printing rank item " , rankItem);
                    if (rankItem.userID === Cookies.get('userId')) {
                        obj = rankItem
                    }
                })
                // console.log("Printing Obj " , obj)
                item.rankings = item.rankings.slice(0, 10);
                if ( obj !== undefined && !item.rankings.includes(obj)) {
                    item.rankings.push(obj)
                }
            });
            // console.log("maneuver Array ", maneuverArray);
            // console.log("leader board array ", leaderBoardArray);
        }
        setManeuverArray(tempManeuverArray);
        setLeaderboardArray(tempLeaderboardArray);
    } , [data])

    // const leaderboardData = [
    // //     {
    // //         "maneuverName": "Steep Turn",
    // //         "data": [
    // //             {
    // //                 "Rank": 1,
    // //                 "Username": "ABC",
    // //                 "Maneuvers": 5,
    // //                 "Score": 50,
    // //             },
    // //             {
    // //                 "Rank": 2,
    // //                 "Username": "DEF",
    // //                 "Maneuvers": 4,
    // //                 "Score": 40,
    // //             },
    // //             {
    // //                 "Rank": 1,
    // //                 "Username": "GHI",
    // //                 "Maneuvers": 3,
    // //                 "Score": 30,
    // //             }
    // //         ]
    // //     },
    // //     {
    // //         "maneuverName": "Steep Turn",
    // //         "data": [
    // //             {
    // //                 "Rank": 1,
    // //                 "Username": "ABC",
    // //                 "Maneuvers": 5,
    // //                 "Score": 50,
    // //             },
    // //             {
    // //                 "Rank": 2,
    // //                 "Username": "DEF",
    // //                 "Maneuvers": 4,
    // //                 "Score": 40,
    // //             },
    // //             {
    // //                 "Rank": 1,
    // //                 "Username": "GHI",
    // //                 "Maneuvers": 3,
    // //                 "Score": 30,
    // //             }
    // //         ]
    // //     }
    // ]
    const tableHeadings = ["Rank", "Username", "# Of Maneuvers", "Best Score"]
    // console.log("Leaderboard data ", leaderboardData[0].data)
    return (
        <div>
            <div>
                <Navbar />
            </div>
            <div>
                <div className='flex justify-between bg-gray-800 mt-4 p-3 text-white text-lg m-4'>
                    <div>
                        <h1>Leaderboard</h1>
                    </div>
                    <div>
                        <button>
                            <Link to="/performance" className='text-sm cursor-pointer bg-white hover:bg-gray-300 text-black p-2 rounded-md'>My Performance Data</Link>
                        </button>
                    </div>
                </div>
                <div>
                    {loading ? (
                        <>
                            <div className="text-center mt-8 text-gray-500">Loading...</div>
                        </>) : <div >
                        {leaderBoardArray.map((data, index) => {
                            return (
                                <div>
                                    <div className='flex  justify-between bg-gray-800 mt-4 p-3 text-white text-lg m-4' >
                                        <h1 clas>{data.title}</h1>
                                    </div>
                                    <div className='mx-3'>
                                        <Table tableData={data.rankings} tableHeadings={tableHeadings} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>}

                </div>
            </div>
        </div>
    )
}

export default Leaderboard